import { ACTIVE_ITEMS } from '@constants/activeItems';
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel } from '@mui/material';
import { RootContext } from 'components/RootContainer';
import { FC, useContext } from 'react';
import { useQuery } from 'react-query';
import { LIMIT_ITEMS_SELECT } from '../../../../../../../../../@constants/Pagination';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 10;

export const UsersField: FC<{
  value: number[] | null;
  onChange: (value: number[] | null) => void;
}> = ({ value, onChange }) => {
  const {
    ChainApi: { settings: SettingsService },
  } = useContext(RootContext);

  const { isLoading, data } = useQuery({
    queryKey: ['get-users'],
    queryFn: () => {
      return SettingsService.acl.user.getAll({
        search: [ACTIVE_ITEMS],
        limit: LIMIT_ITEMS_SELECT,
      });
    },
  });

  const handleChange = (userId: number) => {
    if (userId === ('all' as unknown as number)) {
      onChange(null);
      return;
    }

    const currentValues = value ?? [];
    const newValues = currentValues.includes(userId)
      ? currentValues.filter(id => id !== userId)
      : [...currentValues, userId];

    onChange(newValues.length > 0 ? newValues : null);
  };

  if (isLoading) {
    return <>...</>;
  }

  return (
    <Box
      sx={
        value?.length! > 0
          ? {
              boxShadow: 'inset 0 -1px 0 0 #d2d7de',
              pb: 2,
            }
          : {}
      }
    >
      <FormControl variant="standard" fullWidth>
        <InputLabel shrink>Users</InputLabel>
        <Box
          sx={{
            mt: 3,
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            overflow: 'auto',
          }}
        >
          <FormGroup
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={!value}
                  onChange={() => handleChange('all' as unknown as number)}
                  sx={{ mr: 1 }}
                />
              }
              label="All"
              sx={{ py: 0.5, pl: 1.5 }}
            />
            {(data?.items || [])?.map(user => (
              <FormControlLabel
                key={user.id}
                control={
                  <Checkbox
                    checked={value?.includes(+user.id!) ?? false}
                    onChange={() => handleChange(+user.id!)}
                    sx={{ mr: 1 }}
                  />
                }
                label={`${user?.first_name} ${user?.last_name || ''}`}
                sx={{ py: 0.5, pl: 1.5 }}
              />
            ))}
          </FormGroup>
        </Box>
      </FormControl>
    </Box>
  );
};
